window.UI_ENV = {
    API_URL: 'http://localhost:5251/api/v1/',
    KEYCLOAK_ENDPOINT: 'https://cucumber-dp-keycloak-qa.dev.eks.cucumbersoftware.com',
    KEYCLOAK_REALM: 'data-platform',
    KEYCLOAK_CLIENT_ID: 'data-platform-ui',
    KEYCLOAK_OPTIONS: {
        ON_LOAD: 'login-required',
        CHECK_LOGIN_IFRAME: false,
        SCOPE: 'openid profile email organization',
        ON_INACTIVITY_TIMEOUT: 'logout',
        SESSION_TIMEOUT: 36000000
    },
    ENVIRONMENT: 'local',
    SENTRY_DNS: 'https://ff397e60081777798817357edca2b545@o4505316319166464.ingest.us.sentry.io/4509403578368000',
    SENTRY_MASK_ALL_TEXT: true,
    SENTRY_MASK_ALL_INPUT: true,
    SENTRY_TRACE_SAMPLE_RATE: 1.0,
    SENTRY_REPLAYS_SESSION_SAMPLE_RATE: 1.0,
    SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE: 1.0,
    SENTRY_SEND_DEFAULT_PII: true,
    WEATHER_API_URL: 'http://api.weatherstack.com',
    WEATHER_API_KEY: '', // NEED BE ON THE API - TESTING ONLY
    GOOGLE_MAPS_API_KEY: '',
    GOOGLE_WEATHER_API_URL: 'https://weather.googleapis.com/v1/currentConditions'
}
